export default __webpack_public_path__ + "static/media/goals-new-logo.74d48e45.svg";